<template>
  <div class="login">
    <div class="login__logo">
      <img class="login__logo--img" :src="logo"/>
    </div>
    <el-collapse-transition>
      <el-alert
        v-if="errorCode"
        class="login__alert"
        type="error"
        :closable="false"
        show-icon>
        <h4
          class="login__alert__title"
          slot="title">
          {{ $t(`errors.ERROR_TITLE`) }}
        </h4>
        <p class="login__alert__text">
          {{ $t(`errors.${errorCode}`) }}
        </p>
      </el-alert>
    </el-collapse-transition>
    <el-card class="login__card">
      <h1 class="login__card__title">{{ $t('login.title') }}</h1>
      <el-form class="login__card__form"
               :model="form"
               :rules="rules"
               @submit.native.prevent="submit"
               ref="form">
        <el-form-item
          :label="$t('login.login')"
          class="login__card__form__input"
          prop="login">
          <el-input
            :placeholder="$t('login.login')"
            autofocus
            type="email"
            name="username"
            v-model="form.login"
            suffix-icon="el-icon-message">
          </el-input>
        </el-form-item>
        <el-form-item
          :label="$t('login.password')"
          class="login__card__form__input"
          prop="password">
          <el-input
            :placeholder="$t('login.password')"
            name="password"
            v-model="form.password"
            show-password
            suffix-icon="el-icon-lock">
          </el-input>
        </el-form-item>
        <div class="login__card__form__submit">
          <el-button
            :disabled="isLoginLoading"
            v-loading="isLoginLoading"
            native-type="submit"
            type="primary"
            class="login__card__form__submit--btn">
            {{ $t('login.loginSubmit') }}
          </el-button>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import logoNextories from '@/assets/img/logo_headline.png';

export default {
  name: 'login',
  data() {
    return {
      form: {
        login: '',
        password: '',
      },
      rules: {
        login: [
          {
            required: true,
            message: this.$t('login.loginWarning'),
            trigger: 'blur',
          },
        ],
        password: [
          {
            required: true,
            message: this.$t('login.passwordWarning'),
            trigger: 'blur',
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      isLoginLoading: 'authStore/isLoginLoading',
      stepStore: 'projectStore/step',
    }),
    logo() {
      return logoNextories;
    },
    isRegisterPossible() {
      return process.env.VUE_APP_REGISTER !== 'false';
    },
    errorCode() {
      return this.$route.query.error;
    },
    states() {
      return {
        CREATED: 'loadingAddress',
        LOADING: 'deliveryAddress',
        DELIVERY: 'serviceOfferDates',
        SERVICES: 'furnituresRooms',
        INVENTORY: 'validateConfirm',
        COMPLETED: 'validateDone',
      };
    },
  },
  methods: {
    ...mapActions({
      login: 'authStore/login',
    }),
    redirect() {
      if (this.states[this.stepStore]) {
        this.$router.push({
          name: this.states[this.stepStore],
        });
      } else {
        this.$router.replace({ name: this.states.CREATED })
          .catch((error) => {
            this.$forceUpdate();
            /* eslint-disable no-console */
            console.error('Something happen here!', error,
              'Is something else than undefined precede this message please contact the webmaster');
          });
      }
    },
    submit() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.login({ username: this.form.login, password: this.form.password });
          this.redirectBinded();
        }
      });
    },
  },
  mounted() {
    this.redirectBinded = this.redirect.bind(this);
  },
};
</script>

<style scoped lang="scss">

.login {
  padding-top: 0;
  @include breakpoint(mobile) {
    padding-top: 2rem;
  }
  &__logo {
    text-align: center;
    &--img {
      padding: 20px 40px;
      max-width: 100%;
      @include breakpoint(mobile) {
        max-width: 400px;
      }
    }
  }
  &__card {
    margin: 20px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid $--color-light-grey-blue;
    @include breakpoint(mobile) {
      max-width: 500px;
      margin: 20px auto;
      padding: 20px;
    }
    &__title {
      margin-top: 0;
      font-size: 20px;
      @include breakpoint(mobile) {
        font-size: 28px;
      }
    }
    &__form {
      &__input {
        ::v-deep .el-form-item__label {
          font-size: $--font-size-large;
        }
      }
      &__submit {
        margin-top: 50px;
        margin-bottom: 0;
        &--btn {
          width: 100%;
          font-weight: 700;
          font-size: $--font-size-large;
        }
      }
    }
  }
  &__alert {
    margin: 10px 20px;
    width: auto;
    @include breakpoint(mobile) {
      max-width: 500px;
      margin: 20px auto;
    }
    &__title {
      font-size: 16px;
      margin: 10px 0;
    }
    &__text {
      font-size: $--font-size-small;
    }
  }
}
</style>
